import { createFileRoute } from "@tanstack/react-router";
import DepressionSymptoms from "@/pages/DepressionSymptoms";
export const Route = createFileRoute(
  "/contents/conditions/depression/depression-symptoms",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Depression Symptoms | DSM-V Diagnostic Criteria | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Review DSM-V diagnostic criteria for major depressive disorder. Recognize emotional, physical, and cognitive symptoms of depression in adults.",
        },
        {
          property: "og:title",
          content:
            "Depression Symptoms | DSM-V Diagnostic Criteria | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Review DSM-V diagnostic criteria for major depressive disorder. Recognize emotional, physical, and cognitive symptoms of depression in adults.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/conditions/depression/depression-symptoms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/conditions/depression/depression-symptoms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionSymptoms />;
}
